import { render } from "./PayModalSectionPlan.vue?vue&type=template&id=768ee1fb"
import script from "./PayModalSectionPlan.vue?vue&type=script&lang=js"
export * from "./PayModalSectionPlan.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__